import { Component, Input, OnInit } from '@angular/core';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-documents-uploaded-dialog',
  templateUrl: './documents-uploaded-dialog.component.html',
  styleUrls: ['./documents-uploaded-dialog.component.scss'],
  providers: [DialogService, ConfirmationService],
})
export class DocumentsUploadedDialogComponent implements OnInit {
  isWarranties: boolean = false;
  constructor(
    public ref: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
  ) {}

  ngOnInit(): void {
    this.isWarranties = this.dialogConfig.data.isWarranties;
  }

  close(): void {
    this.ref.close();
  }
}
